"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Components = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _constant = require("../../styles/constant");
var _Badge = _interopRequireDefault(require("../Badge/Badge"));
var _LoadingIndicator = _interopRequireDefault(require("../LoadingIndicator/LoadingIndicator"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
const CheckBox = _styledComponents["default"].input.attrs({
  type: 'checkbox'
})(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  width: ", ";\n  height: ", ";\n"])), (0, _constant.get)('space.20'), (0, _constant.get)('space.20'));
//spread styles
const GroupOption = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n  padding: ", ";\n  ", "\n"])), props => props.variant === 'multi-level' && !props.isRootElement && props.value !== 'selectAll' ? '40px' : props.variant === 'spread' ? '12px' : '0px', props => props.isRootElement && '8px 0', props => props.value === 'selectAll' && "\n      width: 100%;\n      margin-bottom: 20px;\n      border-bottom: solid 1px #dbdbdb;");
const Loading = (0, _styledComponents["default"])(_LoadingIndicator["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  margin: 12px 0 0 64px;\n  label {\n    color: #878787;\n  }\n  background-color: inherit;\n"])));
const multiSpreadOptionsWrapper = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  &.spread .MultiSelect__menu-list {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0;\n  }\n  .nested-optgroup-label {\n    display: flex;\n    flex-direction: column;\n  }\n  .nested-optgroup-content {\n    display: flex;\n    align-items: center;\n    column-gap: 4px;\n    padding: 8px 12px;\n    margin: 0 0 0 12px;\n  }\n  .nested-optgroup-content:hover {\n    background-color: rgb(237, 237, 237);\n    color: black;\n    height: auto;\n    border-radius: 4px;\n  }\n  .rootElement {\n    margin: unset;\n    padding: 0px 12px 0;\n  }\n  .collapsed + div {\n    display: none;\n  }\n  .isGroupNotExpandable {\n    padding: 8px 36px 0;\n  }\n"])));
const DefaultIconWrapper = _styledComponents["default"].span(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), (0, _constant.get)('space.8'));
const Multi = {
  OptionsWrapper: multiSpreadOptionsWrapper
};
const heighLighterUtil = (provided, state) => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    height: 'auto',
    borderRadius: '4px',
    margin: '2px 12px 2px 0',
    width: '96%',
    color: 'black!important',
    '&:hover': {
      backgroundColor: state.isSelected ? '' : 'rgb(237, 237, 237)!important',
      color: 'black!important'
    }
  });
};
const multiValue = provided => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    borderRadius: '10px'
  });
};
const multiValueRemove = provided => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    '&:hover': {
      backgroundColor: 'initial',
      color: 'initial'
    }
  });
};
const noHeighLighterUtil = provided => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    height: 'auto',
    backgroundColor: 'white!important',
    color: 'black!important',
    borderRadius: '4px',
    margin: '2px 12px',
    width: '96%',
    '&:hover': {
      backgroundColor: 'rgb(237, 237, 237)!important',
      color: 'black!important'
    }
  });
};
const groupHeading = (provided, isGroupAllSelectable, isGroupExpandable) => {
  return (0, _extends2["default"])((0, _extends2["default"])({}, provided), {
    padding: '8px 12px 0',
    display: 'flex',
    alignItems: 'center',
    textTransform: 'none',
    columnGap: '4px',
    margin: '0 0 0 12px',
    fontSize: !isGroupAllSelectable && !isGroupExpandable ? '14px' : '16px'
  });
};
const CustomStyles = {
  MultiValue: multiValue,
  MultiValueRemove: multiValueRemove,
  HeighLighterUtil: heighLighterUtil,
  NoHeighLighterUtil: noHeighLighterUtil,
  GroupHeading: groupHeading
};
const LimitTagBadge = (0, _styledComponents["default"])(_Badge["default"])(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: auto;\n"])));
const avatarOptionsWrapper = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  font-size: ", ";\n  font-weight: 400;\n"])), (0, _constant.get)('fontSizes.16'));
const avatarWrapper = _styledComponents["default"].span(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  margin-left: ", ";\n"])), (0, _constant.get)('space.12'));
const avatarLabelWrapper = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n  display: inline-block;\n  margin-left: ", ";\n  color: ", ";\n"])), (0, _constant.get)('space.8'), props => {
  const {
    variant,
    label
  } = props;
  return (label === 'Select All' || label === 'Deselect All') && variant === 'default' ? (0, _constant.get)('colors.primary.blue.600') : '';
});
const avatarSubLabelWrapper = _styledComponents["default"].span(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n  display: block;\n  font-size: ", ";\n  color: ", ";\n"])), (0, _constant.get)('fontSizes.14'), (0, _constant.get)('colors.functional.grey.700'));
const avatarSeparator = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n  border-bottom: solid ", " ", ";\n"])), (0, _constant.get)('space.1'), (0, _constant.get)('colors.functional.grey.300'));
const Avatar = {
  OptionsWrapper: avatarOptionsWrapper,
  AvatarWrapper: avatarWrapper,
  LabelWrapper: avatarLabelWrapper,
  SubLabelWraaper: avatarSubLabelWrapper,
  Separator: avatarSeparator
};
const Components = exports.Components = {
  CheckBox,
  GroupOption,
  Avatar,
  Multi,
  DefaultIconWrapper,
  CustomStyles,
  LimitTagBadge,
  Loading
};